import type { XY } from "../xy";
import { Timing } from "./effect";
import { XYEffect } from "./xyEffect";

export class ShockBlast extends XYEffect {
	static key = "ShockBlast";
	constructor(xy: XY) {
		super(xy);
		this.setTiming(Timing.BEFORE_STATE_UPDATE);
	}
}
